import 'intersection-observer';
import { Ref, useEffect, useRef, useState } from 'react';
import { WeakType } from '../typescript-migration';

export function useIsIntersecting(
  options?: IntersectionObserverInit & { intersectWithinSeconds?: number },
): [Ref<WeakType>, boolean] {
  const [node, setNode] = useState<WeakType>(null);
  const [isIntersecting, setIsIntersecting] = useState<boolean>(false);

  const observer = useRef<IntersectionObserver>(null);
  const timer = useRef<NodeJS.Timeout>(null);

  useEffect(() => {
    if (observer.current) {
      observer.current.disconnect();
    }
    if (timer.current) {
      clearTimeout(timer.current);
    }
    if (isIntersecting) {
      return;
    }

    observer.current = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsIntersecting(true);
      }
    }, options || {});

    if (options?.intersectWithinSeconds) {
      timer.current = setTimeout(() => {
        setIsIntersecting(true);
      }, Math.round(options.intersectWithinSeconds * 1000 * Math.random()));
    }

    const { current: currentObserver } = observer;
    if (node) {
      currentObserver.observe(node);
    }

    return () => currentObserver.disconnect();
  }, [node, options, isIntersecting]);

  return [setNode, isIntersecting];
}
